module.exports = __webpack_public_path__ + "static/media/2012.e8956985.csv";